import { FileQuestion } from 'lucide-react';

import { ButtonLink } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="mx-auto grid min-h-[60vh] max-w-xl place-items-center px-4 text-center">
      <div>
        <FileQuestion className="mx-auto h-10 w-10 text-faint" aria-hidden="true" />
        <h1 className="mt-5 text-2xl font-bold">Page introuvable</h1>
        <p className="mt-2 text-muted">
          La ressource demandée n'existe pas, n'est pas publiée, ou n'est pas accessible avec votre
          compte.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <ButtonLink to="/">Retour à l'accueil</ButtonLink>
          <ButtonLink to="/parcours" variant="outline">
            Voir le catalogue
          </ButtonLink>
        </div>
      </div>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div className="mx-auto grid min-h-[60vh] max-w-xl place-items-center px-4 text-center">
      <div>
        <h1 className="text-2xl font-bold">Accès refusé</h1>
        <p className="mt-2 text-muted">
          Votre rôle ne permet pas d'accéder à cette section. Si vous pensez qu'il s'agit d'une
          erreur, contactez un administrateur de la plateforme.
        </p>
        <ButtonLink to="/app" className="mt-7">
          Retour à mon tableau de bord
        </ButtonLink>
      </div>
    </div>
  );
}
